import { useParams } from 'react-router-dom';
import { languages, fallbackLng } from '@i18n/settings';

export function useRouteLang() {
  const { lang } = useParams<{ lang: string }>();

  // Validate and return the language parameter
  if (!lang || !languages.includes(lang)) {
    return fallbackLng;
  }

  return lang;
}
